<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">

            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.banner.query.type')" prop="type">
                <a-select v-model="queryParam.type" :placeholder="$t('views.banner.query.typePlaceholder')" allow-clear>
                  <a-select-option :value="0">{{ $t('views.banner.type.home') }}</a-select-option>
                  <a-select-option :value="1">{{ $t('views.banner.type.company') }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item :label="$t('views.banner.query.title')" prop="title">
                <a-input v-model="queryParam.title" :placeholder="$t('views.banner.query.titlePlaceholder')" allow-clear/>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.banner.query.link')" prop="link">
                  <a-input v-model="queryParam.link" :placeholder="$t('views.banner.query.linkPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.banner.query.linkUrl')" prop="linkUrl">
                  <a-input v-model="queryParam.linkUrl" :placeholder="$t('views.banner.query.linkUrlPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item :label="$t('views.banner.query.sort')" prop="sort">
                  <a-input v-model="queryParam.sort" :placeholder="$t('views.banner.query.sortPlaceholder')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('views.banner.btn.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('views.banner.btn.reset') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['banner:banner:add']">
          <a-icon type="plus" />{{ $t('views.banner.btn.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['banner:banner:edit']">
          <a-icon type="edit" />{{ $t('views.banner.btn.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['banner:banner:remove']">
          <a-icon type="delete" />{{ $t('views.banner.btn.delete') }}
        </a-button>
        <table-setting
          :key="$i18n.locale"
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: tableScrollX }"
      >
        <div
          slot="textCell"
          slot-scope="text, record"
          class="banner-table-cell-ellipsis"
          :title="formatBannerTextCell(text, record)"
        >{{ formatBannerTextCell(text, record) }}</div>
        <img style="width: 48px;height: 48px;" v-image-preview :src="record.imgUrl" slot="imgUrl" slot-scope="text, record">
        <a-input-number
          slot="sort"
          slot-scope="text, record"
          :min="0"
          :step="1"
          v-model="record.sort"
          @change="changeInput($event,record)" />
        <a-switch slot="isVisible" slot-scope="text, record" v-model="record.isVisible" @change="onChange($event,record)" />
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['banner:banner:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['banner:banner:edit']">
            <a-icon type="edit" />{{ $t('views.banner.btn.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['banner:banner:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['banner:banner:remove']">
            <a-icon type="delete" />{{ $t('views.banner.btn.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="paginationShowTotal"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBanner, delBanner, updateBanner } from '@/api/banner/banner'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Banner',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      columns: [],
      queryParam: {
        type: undefined,
        title: null,
        titleEn: null,
        content: null,
        contentEn: null,
        link: null,
        linkUrl: null,
        imgUrl: null,
        linkType: null,
        isVisible: null,
        sort: null,
        pageNum: 1,
        pageSize: 10,
        sortField: 'sort',
        sortOrder: 'ASCEND'
      }
    }
  },
  created () {
    this.buildColumns()
    this.getList()
  },
  computed: {
    /** 列宽之和，避免 scroll x=max-content 导致 width 失效 */
    tableScrollX () {
      return 1500
    }
  },
  watch: {
    '$i18n.locale' () {
      this.buildColumns()
    }
  },
  methods: {
    paginationShowTotal (total) {
      return this.$t('views.banner.pagination.total', { total })
    },
    stripHtmlForTable (value) {
      if (value == null) {
        return ''
      }
      return String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
    },
    /** 位置为首页(type=0) 时，标题/内容列统一显示 - */
    formatBannerTextCell (text, record) {
      const type = record && record.type
      if (type === 0 || type === '0') {
        return '-'
      }
      const raw = this.stripHtmlForTable(text)
      return raw !== '' ? raw : '-'
    },
    buildColumns () {
      this.columns = [
        {
          title: this.$t('views.banner.column.id'),
          dataIndex: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('views.banner.column.type'),
          dataIndex: 'type',
          width: 100,
          align: 'center',
          customRender: (t) => {
            if (t === 0 || t === '0') {
              return this.$t('views.banner.type.home')
            }
            if (t === 1 || t === '1') {
              return this.$t('views.banner.type.company')
            }
            return t
          }
        },
        {
          title: this.$t('views.banner.column.title'),
          dataIndex: 'title',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'textCell' }
        },
        {
          title: this.$t('views.banner.column.titleEn'),
          dataIndex: 'titleEn',
          width: 160,
          align: 'center',
          scopedSlots: { customRender: 'textCell' }
        },
        {
          title: this.$t('views.banner.column.content'),
          dataIndex: 'content',
          width: 220,
          align: 'center',
          scopedSlots: { customRender: 'textCell' }
        },
        {
          title: this.$t('views.banner.column.contentEn'),
          dataIndex: 'contentEn',
          width: 220,
          align: 'center',
          scopedSlots: { customRender: 'textCell' }
        },
        {
          title: this.$t('views.banner.column.imgUrl'),
          dataIndex: 'imgUrl',
          width: 88,
          align: 'center',
          scopedSlots: { customRender: 'imgUrl' }
        },
        {
          title: this.$t('views.banner.column.status'),
          dataIndex: 'isVisible',
          align: 'center',
          scopedSlots: { customRender: 'isVisible' }
        },
        {
          title: this.$t('views.banner.column.sort'),
          dataIndex: 'sort',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'sort' }
        },
        {
          title: this.$t('views.banner.column.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          align: 'center'
        },
        {
          title: this.$t('views.banner.column.operation'),
          dataIndex: 'operation',
          width: 180,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    },
    changeInput (e, record) {
      this.updateBannerData(record)
    },
    updateBannerData (record) {
      updateBanner(record).then(res => {
        if (res && res.success !== false) {
          this.$message.success(this.$t('views.banner.msg.inlineSaveOk'))
        }
      })
    },
    onChange (e, record) {
      const recordData = JSON.parse(JSON.stringify(record))
      recordData.isVisible = e ? 1 : 0
      this.updateBannerData(recordData)
      record.isVisible = e ? 1 : 0
    },
    getList () {
      this.loading = true
      pageBanner(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        type: undefined,
        title: undefined,
        titleEn: undefined,
        content: undefined,
        contentEn: undefined,
        link: undefined,
        linkUrl: undefined,
        imgUrl: undefined,
        linkType: undefined,
        isVisible: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10,
        sortField: 'sort',
        sortOrder: 'ASCEND'
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('views.banner.confirm.deleteTitle'),
        content: this.$t('views.banner.confirm.deleteContent', { ids }),
        onOk () {
          const data = []
          that.ids.map(id => data.push({ id: id }))
          return delBanner(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('views.banner.msg.deleteSuccess'),
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('views.banner.confirm.exportTitle'),
        content: this.$t('views.banner.confirm.exportContent'),
        onOk () {
          that.download('banner/banner/export', {
            ...that.queryParam
          }, that.$t('views.banner.export.filename', { time: new Date().getTime() }))
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style scoped>
.banner-table-cell-ellipsis {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
